import PropTypes from "prop-types";

// @mui
import { Typography, Grid } from "@mui/material";

export default function RowDetail(props) {
  const { nombre, valor, r1, r2 } = props;

  return (
    <Grid container>
      <Grid container item xs={r1} justifyContent={"start"}>
        <Typography component={"span"} variant="title" fontWeightBold>
          {nombre}
          {":"}
        </Typography>
      </Grid>
      <Grid container item xs={r2} justifyContent={"start"} >
        <Typography component={"span"} variant="detalle" >
          {valor}
        </Typography>
      </Grid>
    </Grid>
  );
}
RowDetail.propTypes = {
  nombre: PropTypes.string,
  valor: PropTypes.string,
  r1: PropTypes.number,
  r2: PropTypes.string,
};

RowDetail.defaultProps = {
  nombre: "Nombre",
  valor: "valor",
  r1: 6,
  r2: "auto",
};
